import React from "react";
import { Table, TableBody } from "@mui/material";
import { TransferBreakdownTableAmountRow, TransferBreakdownTableHeaderRow } from "./components/TransferBreakdownRow";
import { red } from "@mui/material/colors";

export default function SalesTransferBreakdownTable({salesTransferBreakdownInfo}) {
  return (
    <Table>
      <TableBody>
        <TransferBreakdownTableHeaderRow
          name="売掛集計"
          bgcolor={red[300]}
        />
        <TransferBreakdownTableAmountRow
          name="(1) 受託軽減税率対象(税抜)売掛"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.entrustedSalesPriceForReducedTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(2) 受託普通税率対象(税抜)売掛"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.entrustedSalesPriceForRegularTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(3) 受託外軽減税率対象(税抜)売掛"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.nonEntrustedSalesPriceForReducedTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(4) 受託外普通税率対象(税抜)売掛"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.nonEntrustedSalesPriceForRegularTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(5) 県内経済連売上(税抜)金額"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.totalEconomicFederationSalesPrice : null}
        />
        <TransferBreakdownTableAmountRow
          name="(6) 地物売上(税抜)金額"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.totalLocalSalesPrice : null}
        />
        <TransferBreakdownTableAmountRow
          name="(7) 売上消費税"
          amount={salesTransferBreakdownInfo ? salesTransferBreakdownInfo.totalTaxPrice : null}
        />
      </TableBody>        
    </Table>
  )
}
